export const howMuchData = {
  title: 'How much did you pay for it?',
  imgObj: {
    src: 'https://media.product.which.co.uk/prod/images/original/35a9c0e3cc29-tooliconmoney.jpg',
    alt: '',
  },
}
